import styled from '@mint-lib/styled';
import AccordionSummaryM, {
  AccordionSummaryProps as AccordionSummaryPropsM,
} from '@mui/material/AccordionSummary';

export interface AccordionSummaryBasicProps extends AccordionSummaryPropsM {
  /**
   * The content of the component.

   */
  children?: React.ReactNode;

  /**
   * Override or extend the styles applied to the component.
  
   */
  classes?: AccordionSummaryPropsM['classes'];

  /**
   * This prop can help identify which element has keyboard focus. The class name will be applied when the element gains the focus through keyboard interaction.
  
   * */
  focusVisibleClassName?: string;

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: AccordionSummaryPropsM['sx'];
}

/**
 * @deprecated Use Accordion components from @mint-lib/tw-components instead
 */
function AccordionSummaryBasic(props: AccordionSummaryBasicProps) {
  return (
    <StyledAccordionSummary {...props}>{props.children}</StyledAccordionSummary>
  );
}

export default AccordionSummaryBasic;

const StyledAccordionSummary = styled(AccordionSummaryM)(({ theme }) => ({
  '&.MuiAccordionSummary-root.Mui-expanded': {
    margin: '0px',
    minHeight: '0px',
  },
  '.MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.icon.primary,
  },
  '.MuiAccordionSummary-content': {
    margin: '0px',
    height: '29px',
  },
  '.MuiAccordionSummary-content.Mui-expanded': {
    margin: '0px',
    minHeight: '0px',
  },

  borderRadius: '8px',
  minHeight: '40px',
  boxSizing: 'border-box',
  gap: '8px',
}));
